// extracted by mini-css-extract-plugin
export default {"thankYouMessage":"Rll3q1","errorMessage":"iygXp3","errorIcon":"SvZOA4"};